import {useEffect, useState} from 'react';
import {useCookies} from "react-cookie";
import {useSearchParams} from "react-router-dom";

function useAuditLog() {
    const [auditLogs, setAuditLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [endDate, setEndDate] = useState(""); // End date input
    const [startDate, setStartDate] = useState(""); // End date input
    const [currentPage, setCurrentPage] = useState(0); // Page starts from 0
    const [totalPages, setTotalPages] = useState(0); // Total pages
    const [table, setTable] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const [search, setSearch] = useState("");

    const [error, setError] = useState(null);
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookies.idToken
    }

    const fetchLogPage = async (page) => {
        try {

            if (table && !loading) {
                setLoading(true);
                setAuditLogs([]);
                let url = `${apiRoot}/backoffice/logs/by-table/${table}?page=${page}&size=20&sortBy=changedAt,desc`;
                if (startDate) {
                    url += `&from=${startDate}`;
                }
                if (endDate) {
                    url += `&to=${endDate}`;
                }
                if (search) {
                    url += `&user=${search}`;
                }
                const response = await fetch(url, {headers: apiHeaders})
                const data = await response.json();
                setAuditLogs(data.content);
                setTotalPages(data.totalPages);
                setLoading(false);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        let tableParam = searchParams.get('table');
        if (tableParam) {
            setTable(tableParam);
        }
        fetchLogPage(currentPage);
    }, [startDate, endDate, currentPage, table, search]);

    return {
        auditLogs, setAuditLogs, loading, setLoading,
        error, setError, currentPage, setCurrentPage, totalPages,
        startDate, setStartDate, endDate, setEndDate, table, setTable, search, setSearch
    };
}

export default useAuditLog;
